var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Error',{attrs:{"title":"ページが見つかりません","lead":"お探しのページは見つかりません"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v("\n    お探しのページは、削除されたか、名前が変更された可能性があります。\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }